/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */

export type TranslationLanguage = typeof TranslationLanguage[keyof typeof TranslationLanguage];


export const TranslationLanguage = {
  English: 'English',
  Spanish: 'Spanish',
  French: 'French',
  German: 'German',
  Italian: 'Italian',
  Portuguese: 'Portuguese',
  Hindi: 'Hindi',
  Japanese: 'Japanese',
  Chinese: 'Chinese',
  Korean: 'Korean',
} as const;
